import { useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../lib/api.js";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await apiFetch<{ ok: true; message: string }>("/api/auth/forgot-password", {
        method: "POST",
        body: { email: email.trim() }
      });
      setMessage(res.message);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="centerPage">
      <div className="card pageNarrow wFull">
        <div style={{ fontWeight: 900, fontSize: 18, letterSpacing: "-0.015em", marginBottom: 6 }}>Reset password</div>
        <div className="help" style={{ marginBottom: 12 }}>
          Enter your email and we’ll send you a link to choose a new password.
        </div>

        {!done ? (
          <form onSubmit={(e) => void onSubmit(e)} style={{ display: "grid", gap: 10 }}>
            <label className="field">
              <span className="label">Email</span>
              <input className="input" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" autoFocus />
            </label>
            <button type="submit" disabled={loading || email.trim() === ""} className="btn btnPrimary">
              Send reset link
            </button>
            <div style={{ marginTop: 4 }}>
              <Link to="/login" className="muted" style={{ fontSize: 13 }}>
                Back to sign in
              </Link>
            </div>
          </form>
        ) : (
          <div>
            <div className="muted" style={{ marginBottom: 16 }}>
              {message}
            </div>
            <Link to="/login" className="btn btnPrimary">
              Back to sign in
            </Link>
          </div>
        )}

        {error && (
          <div style={{ marginTop: 16 }}>
            <div style={{ fontWeight: 800, color: "var(--danger-text)", marginBottom: 4 }}>Error</div>
            <div className="muted">{error}</div>
          </div>
        )}
      </div>
    </div>
  );
}
